export { SchoolEntity } from './school-entity';
export { SchoolEntityList } from './school-entity-list';

export type { Entity as SchoolEntityType } from './school-entity';
